<template>
  <Modal
    :id="'cmp-settings-invoice-item-form'"
    @cancelled="onCancel"
    :loadingFlag="loadingFlag"
  >
    <template slot="header"
      >{{$t('invoice_item')}}</template
    >

    <template slot="body">
      <div class="form-group">
        <TextField
          class="m1"
          :id="'item_name'"
          v-bind="textFieldConfig"
          :value="invoice_item.item_name"
          :placeholder="$t('item_name')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <Dropdown
          :options="invoice_types"
          class="m2"
          :selected="invoice_types.find(t => t.value == invoice_item.item_type)"
          :placeholder="$t('item_type')"
          v-on:selectedChange="e => onDropdownChange('item_type', e)"
          :listHeight="95"
          box
        ></Dropdown>
        <TextField
          class="m1"
          :id="'invoice_line_text'"
          v-bind="textFieldConfig"
          :value="invoice_item.invoice_line_text"
          :placeholder="$t('invoice_line_text')"
          @valuechanged="onTextFieldValueChange"
        ></TextField>
        <Dropdown
          :options="event_artists"
          class="m2"
          :selected="
            event_artists.find(e => e.value == invoice_item.event_or_artist)
          "
          :placeholder="$t('event_or_artist')"
          v-on:selectedChange="e => onDropdownChange('event_or_artist', e)"
          :listHeight="95"
          box
        ></Dropdown>
        
        <v-layout row wrap>
          <v-flex md6 pr-2>
            <Dropdown
              :options="vat_types"
              class="m2"
              :selected="vat_types.find(e => e.value == invoice_item.vat_type)"
              :placeholder="$t('default_vat')"
              v-on:selectedChange="e => onDropdownChange('vat_type', e)"
              :listHeight="95"
              box
            ></Dropdown>
          </v-flex>
          <v-flex>
            <TextField
              class="m1"
              :id="'account_no'"
              v-bind="textFieldConfig"
              :value="invoice_item.account_no"
              :placeholder="$t('invoice_items_account_no')"
              @valuechanged="onTextFieldValueChange"
            ></TextField>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6>
            <div class="dt-checkbox-control">
              <div class="dt-checkbox v2 s1">
                <input
                  type="checkbox"
                  :name="'percent_flag'"
                  :id="'percent_flag'"
                  :checked="invoice_item.percent_flag == '1'"
                  @click="e => onCheckboxChange(e)"
                />
                <div class="checkmark"></div>
              </div>
              <div class="dt-checkbox-label">{{$t('is_percent_q')}}</div>
            </div>
          </v-flex>
          <v-flex md6>
            <TextField
              class="m1"
              :id="'percent_amount'"
              v-bind="textFieldConfig"
              :value="invoice_item.percent_amount"
              :placeholder="$t('percent_amount')"
              @valuechanged="onTextFieldValueChange"
            ></TextField>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 pr-2>
            <TextField
              class="m1"
              :id="'default_due_days'"
              v-bind="textFieldConfig"
              :value="invoice_item.default_due_days"
              :placeholder="$t('set_due_days')"
              @valuechanged="onTextFieldValueChange"
            ></TextField>
          </v-flex>
          <v-flex md6>
            <Dropdown
              :options="daysBeforeOptions"
              class="m2"
              :selected="
                daysBeforeOptions.find(
                  e => e.value == invoice_item.default_date_type
                )
              "
              :placeholder="$t('days_beforeafter')"
              v-on:selectedChange="
                e => onDropdownChange('default_date_type', e)
              "
              :listHeight="95"
              box
            ></Dropdown>
          </v-flex>
        </v-layout>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button class="dt-button v1 s6" @click.stop="onInvoiceItemSubmit">
        {{ $t("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import { BookingSettingsService } from "../../services/booking-settings.service";
import {
  getInvoiceTypes,
  getEventArtist,
  getVatTypes,
  getDaysBeforeOptions
} from "../../models/invoice-line.model";

export default {
  components: {
    Modal
  },
  props: {},
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false
      },
      invoice_item: this.getInvoiceItem(),
      invoice_types: getInvoiceTypes(),
      event_artists: getEventArtist(),
      vat_types: getVatTypes(),
      daysBeforeOptions: getDaysBeforeOptions(),

      submitted: false
    };
  },
  mounted: async function() {
    if (this.isEditMode) {
      const itemDetails = await BookingSettingsService.findInvoiceItemDetails({
        invoice_item_id: this.invoice_item_id
      });
      console.log(itemDetails);
      this.invoice_item = itemDetails.data.invoice_item;
      console.log("Log: this.invoice_item", this.invoice_item);
    } else {
      this.invoice_item = this.getInvoiceItem();
    }
  },
  computed: {
    invoice_item_id: function() {
      return this.$route.query.invoice_item_id;
    },
    mode: function() {
      return this.$route.query.mode;
    },
    isEditMode: function() {
      return this.mode == "edit";
    },
    loadingFlag: function() {
      if (this.isEditMode) {
        return !this.invoice_item.invoice_item_id;
      } else {
        return this.submitted;
      }
    }
  },
  methods: {
    onInvoiceItemSubmit: function() {
      this.submitted = true;

      this.$emit("done", {
        mode: this.mode,
        invoice_item: this.invoice_item
      });
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onTextFieldValueChange: function(id, value) {
      // this.$set(this.invoice_item, id, value);
      // console.log(this.invoice_item);
      this.invoice_item[id] = value;
    },
    onDropdownChange: function(name, value) {
      this.invoice_item[name] = value.value;
    },
    onCheckboxChange: function(event) {
      this.invoice_item.percent_flag = event.target.checked ? "1" : "0";
    },
    getInvoiceItem: function() {
      return {
        item_type: "",
        invoice_line_text: "",
        default_date_type: "",
        invoice_item_id: "",
        default_due_days: "",
        event_or_artist: "",
        vat_type: "",
        item_name: "",
        percent_amount: "",
        percent_flag: "",
        account_no: "",
      };
    }
    //MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-settings-invoice-item-form {
  .dt-checkbox-control {
    display: flex;
    padding-top: 12px;
    .dt-checkbox {
      max-width: 40px;
      margin: 3px 10px 0px 0px;
    }
  }
}
</style>
